// src/lib/uploadStore.js
// Module-level upload state — lives OUTSIDE React, so uploads survive
// navigation: the Docs & Media page unmounts when you visit another section,
// but this object (and the in-flight upload promises) keep running. Any
// component can subscribe (listeners) to render live progress; UploadTray
// shows a floating pill app-wide while an upload is running.
export const uploadStore = {
  uploading: false,
  progress: 0,
  preparing: false,
  queuedCount: 0,
  active: false,   // an upload loop is currently running
  queue: [],       // files dropped while a batch is in flight
  cancelled: false,   // user hit Cancel — stop everything, quietly
  abort: null,        // AbortController for the in-flight requests
  pendingAssets: [],  // asset ids created this batch but not yet completed
  listeners: new Set(),
  set(patch) { Object.assign(this, patch); this.listeners.forEach((fn) => fn()); },
  // One cancel for every surface (dropzone overlay, floating pill): stops the
  // queue, aborts in-flight requests, and lets the batch loop clean up the
  // half-done assets quietly.
  cancel() {
    this.cancelled = true;
    this.queue.length = 0;
    try { if (this.abort) this.abort.abort(); } catch (_) {}
    this.set({ queuedCount: 0, preparing: false });
  },
};
